export const getCssVariableValue = (variable: string) => {
  if (typeof window === 'undefined') {
    return ''
  }

  const searchString = variable.replace('var(', '').replace(')', '')
  return getComputedStyle(document.body).getPropertyValue(searchString)
}

export const getCssVariableIntValue = (variable: string) => {
  if (typeof window === 'undefined') {
    return 0
  }

  const searchString = variable.replace('var(', '').replace(')', '')
  return parseInt(
    getComputedStyle(document.body).getPropertyValue(searchString)
  )
}
